
import React from 'react';
import Layout from '@/components/Layout/Layout';
import CalorieCalculator from '@/components/SpecialCalculators/HealthCalculators/CalorieCalculator';

const CalorieCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Calorie Calculator</h1>
        <p className="text-gray-600 mb-8">
          Calculate your daily calorie needs based on your age, gender, weight, height, and activity level.
        </p>
        
        <CalorieCalculator />
        
        <div className="mt-12 p-6 bg-blue-50 rounded-lg">
          <h2 className="text-xl font-bold mb-2">About Calorie Calculator</h2>
          <p className="text-gray-700 mb-4">
            This calorie calculator helps you determine your daily calorie needs based on your physical characteristics and activity level. 
            It uses the Mifflin-St Jeor equation, which is considered one of the most accurate formulas for estimating calorie requirements.
          </p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li>Calculate your basal metabolic rate (BMR)</li>
            <li>Determine your total daily energy expenditure (TDEE)</li>
            <li>Adjust calories based on your weight goals</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default CalorieCalculatorPage;
